import { faker } from '@faker-js/faker';
import _ from "lodash";
import colorData from '../data/colors.json'
import names from '../data/names.json'
import biblical from '../data/biblical.json'
import gods from '../data/gods.json'
import numerical from '../data/numerical.json'
import prefixes from '../data/prefixes.json'
import shakespeare from '../data/shakespeare.json'
import suffixes from '../data/suffixes.json'
import themes from '../data/themecolors.json'

const rndNum = (data) => {
  return _.random(data.length - 1)
}

export const rollOnTable = (data, currentValue = null) => {
  if (currentValue) {
    const nextSet = _.filter((data), function(datum) {return datum.description !== currentValue.description})
    return _.sample(nextSet)
  } else {
    return _.sample(data)
  }
}


export const rndPlanetName = () => {
  const nameType = rollOnTable(names)
  let prefix = ""
  let primaryName = ""
  let suffix = ""

  switch (nameType.name) {
    case "shakespeare":
      primaryName = rollOnTable(shakespeare)
      break
    case "biblical":
      primaryName = rollOnTable(biblical)
      break
    case "god":
      primaryName = rollOnTable(gods)
      break
    default:
      primaryName = {text: "Kasei Valles"}
  }

  if (nameType.prefix) {
    const {text} = rollOnTable(prefixes)
    if (_.endsWith(text, '-')) {
      prefix = text
    } else {
      prefix = `${text} `
    }
  } 

  if (nameType.suffix) {
    const {text} = nameType.suffix === "numerical" ? rollOnTable(numerical) : rollOnTable(suffixes)
    if (_.startsWith(text, '\'')) {
      suffix = text
    } else {
      suffix = ` ${text}`
    }
    
  }
  return `${prefix}${primaryName.text}${suffix}`
}

export const rndmzPlanet = (planetData) => {
  const headings = _.keys(planetData[0])

  const randomPlanet = _.reduce(headings, function(result, heading) {
    result[heading] = planetData[rndNum(planetData)][heading]
    return result
  }, {})

  return randomPlanet
}

export const rndmzViewbox = () => {
  const zoom = _.random(1350, 1650)
  const randomX = _.random(-300, 2700)
  const randomY = _.random(-300, 2700)

  return (`${randomX} ${randomY} ${zoom} ${zoom}`)
}

export const rndAngle = () => {
  return `${_.random(0, 360)}deg`
}

export const rndPlanetNumber = () => {
  const prefix = faker.random.alpha(_.random(1,2))
  const suffix = faker.random.numeric(_.random(1,4))
  return `${prefix}-${suffix}`
}

export const doubleRoll = (data) => {
  const result = [rollOnTable(data)]
  const nextSet = _.filter((data), function(datum) {return datum.description !== result[0].description})
  result.push(nextSet[_.random(nextSet.length - 1)])
  return result
}

 export const rndGraphData = () => {
    const data = [];
    for (let i = 0, v = 2; i < 180; ++i) {
      v += Math.random() - 0.5;
      v = Math.max(Math.min(v, 4), 0);
      data.push({step: i, value: v});
    }
    return data
  }

export const rndText = () => {
  return faker.lorem.words(_.random(5, 18))
}

export const rndmColors = (theme) => {
  if (theme.primaryColor === themes.gameboy.primaryColor) {
    return {
      "background": "#88c070",
      "ocean": "#346856",
      "texture": "#e0f8d0",
      "highlight": "#e0f8d0",
      "id": "gameboy"
    }
  } else if (theme.primaryColor === themes.printer.primaryColor) {
    return {
      "background": "#000000",
      "ocean": "#FFFFFF",
      "texture": "#979797",
      "highlight": "#000000",
      "id": "printer"
    }  
  } else
  return rollOnTable(colorData)
}

export const hasWater = () => {
  const waterCheck = _.random(1,5)
  return waterCheck !== 1
}
